
function getVisible(array) {
    if (Array.isArray(array)) {
        return array.filter(i => i.style['visibility'] !== 'hidden' && i.style['display'] !== 'none' && i.style['opacity'] !== 0 && i.style['opacity'] !== "0");
    } else {
        return []
    }

}

function getEnabled(array) {
    if (Array.isArray(array)) {
        return array.filter(i => !i.disabled);
    } else {
        return []
    }
}

function getFirstElement(array) {
    return array.length > 0 ? array[0] : null;
}
function toArray(array) {
    return [].slice.call(array)
}

function closestClassName(elem, className, parent = null) {
    let x = elem.parentNode;
    while (x !== parent && x !== null) {
        if (x.className.indexOf(className) !== -1) {
            return x;
        }
        x = x.parentNode ? x.parentNode : null;
    }
    return null;
}

/**
 * Nastavení focusu na první viditelný nezakázaný element pro editaci.
 * @param el {Object} container
 * @param selectContent {bool} true, pokud má být obsah vybraný (např. u input type text)
 * @return {bool} true, pokud se podařilo najít a nastavit focus
 */
export default function setInputFocus(el, selectContent = false) {
    if (!el) {
        // console.log("CANNOT FIND FOCUS EL, PARENT el is null")
        return false;
    }
    //var elem = $('input:visible:enabled:not([type=radio])', el).get(0);
    let elem = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('input')))));


    // var select = $('select:visible:enabled', el).get(0);
    let select = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('select')))));
    elem = chooseInputEl(elem, select);

    // var textarea = $('textarea:visible:enabled', el).get(0);
    let textarea = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('textarea')))));
    elem = chooseInputEl(elem, textarea);

    //var button = $('button:visible:enabled:not([data-toggle=dropdown])', el).get(0);
    let button = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('button')))).filter(i => i.getAttribute("data-toggle") !== "dropdown"));
    //if (button && button.closest(".card-header") === null)
    if (button && closestClassName(button, ".card-header", el) === null) { // chceme jen tlačítka, která nejsou v card header
        elem = chooseInputEl(elem, button);
    }

    elem = chooseInputEl(elem, button);

    // Vlastní prvky podle definovaného tab indexu
    let custom = getFirstElement(toArray(el.querySelectorAll('div,shortcut')).filter(i => i.getAttribute("tabIndex") >= 0));
    elem = chooseInputEl(elem, custom);

    if (elem) {
        // console.log("SET_FOCUS", elem)
        elem.focus();
        if (selectContent) {
            elem.select && elem.select();
        }
        return true
    }
    return false
}

function chooseInputEl(el1, el2) {
    let result = null;

    if (el1 && el2) {
        let el1Rect = el1.getBoundingClientRect();
        let el2Rect = el2.getBoundingClientRect();

        if (el1Rect.top < el2Rect.top) {
            result = el1;
        } else if (el1Rect.top === el2Rect.top && el1Rect.left < el2Rect.left) {
            result = el1;
        } else {
            result = el2;
        }
    } else if (!el1 && el2) {
        result = el2;
    } else if (el1 && !el2) {
        result = el1;
    }
    return result;
}
